/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import useCalcLinks from "../WebAppCalculators/useCalcLinks";

interface IProps {
  content: string;
}

const InfoContainer = styled.ul`
  padding-left: 24px;
`;

const Text = styled.li`
  color: white;
  margin: 10px 0;
  font-size: 1.1rem;
`;

const ListItem = styled.div`
  margin-left: 10px;
`;


// const Italic = styled.Text`
//   color: white;
//   font-style: italic;
// `;

// const Bold = styled.Text`
//   color: white;
//   font-weight: bold;
// `;

const SubListItem = styled.ul`
  margin-left: 20px;
`;

const LinkText = styled.a`
  color: #8774ff;
  cursor: pointer;
  display: inline;
`;

const DosageInfo: React.FC<IProps> = (props: IProps) => {
  const [contentArray, setContentArray] = useState<any>([]);
  const handleNav = useCalcLinks();

  function linkParser(value: any) {
    if (value.includes("#")) {
      const fullUnparsed = value.split("#");
      const arrayToReturn: any = [];
      fullUnparsed?.forEach((string: string) => {
        if (!string) return;
        
        const regex = /(?<={)(.*)(?=})/gm;
        const linkParams = string.match(regex);
        if (string?.includes("{") && linkParams) {
          const textToAdd = string.replace(`{${linkParams[0]}}`, "");
          arrayToReturn.push(
            <LinkText
              key={Math.random()}
              onClick={() => handleNav(JSON.parse(`{${linkParams[0]}}`))}
            >
              {textToAdd}
            </LinkText>
          );
        } else {
          arrayToReturn.push(string);
        }
      });
      return (
        <Text key={Math.random()}>
          {arrayToReturn}
        </Text>
      );
    }
  }

  useEffect(() => {
    const temp = props.content.split(";");
    setContentArray(temp);
  }, []);

  return (
    <InfoContainer>
      {(() => {
        let skip = 0;

        return contentArray.map((content: any, index: number) => {
          if (skip > 0) {
            skip -= 1;
            return null;
          }

          if (typeof content !== "string" || !content.trim()) {
            return null;
          }

          const nextItem = contentArray[index + 1];
          const nextNextItem = contentArray[index + 2];

          if (content.includes("@")) {
            const parsed = content.replace("@", "");
            return (
              <SubListItem key={index}>
                <Text>{`${parsed}`}</Text>
              </SubListItem>
            );
          }

          // Case 1: plain text followed by link marker chunk
          if (
            !content.includes("#") &&
            nextItem &&
            typeof nextItem === "string" &&
            nextItem.includes("#")
          ) {
            // Optionally also merge the chunk after the link if it's plain text
            let combinedContent = content + nextItem;
            let toSkip = 1;

            if (
              nextNextItem &&
              typeof nextNextItem === "string" &&
              !nextNextItem.includes("@") &&
              !nextNextItem.includes("#")
            ) {
              combinedContent += nextNextItem;
              toSkip = 2;
            }

            const parsed = linkParser(combinedContent);
            if (parsed) {
              skip = toSkip;
              return (
                <ListItem key={index}>
                  {parsed}
                </ListItem>
              );
            }
          }

          // Case 2: current chunk already contains link markup
          if (content.includes("#")) {
            // If next item is plain text (no @ or #), merge it into this line
            if (
              nextItem &&
              typeof nextItem === "string" &&
              !nextItem.includes("@") &&
              !nextItem.includes("#")
            ) {
              const combinedContent = content + nextItem;
              const parsed = linkParser(combinedContent);
              skip = 1;
              return parsed ? (
                <ListItem key={index}>
                  {parsed}
                </ListItem>
              ) : null;
            }

            const parsed = linkParser(content);
            return parsed ? (
              <ListItem key={index}>
                {parsed}
              </ListItem>
            ) : null;
          }

          // Case 3: plain text (no link markers)
          return (
            <ListItem key={index}>
              <Text>{`${content}`}</Text>
            </ListItem>
          );
        });
      })()}
    </InfoContainer>
  );
};

export default DosageInfo;
